export const PROFESSIONAL_SPECIALTIES = [
  'Psicólogo(a)',
  'Neuropsicólogo(a)',
  'Psiquiatra',
  'Psicopedagogo(a)',
  'Neuropsicopedagoga',
  'Pedagoga',
  'Pedagoga (musicoterapia)',
  'Fonoaudiólogo(a)',
  'Terapeuta Ocupacional',
  'Acompanhante Terapêutico',
  'Orientador Parental',
  'Neuropediatra',
  'Neurologista',
  'Médico(a) Pediatra',
  'Médico(a) Generalista',
  'Analista do Comportamento (ABA)',
  'Assistente Social',
  'Educador(a) Especial',
  'Fisioterapeuta',
  'Musicoterapeuta',
  'Nutricionista',
  'Profissional Administrativo',
  'Outro',
] as const
